import {Component, computed, input, model, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TextareaModule} from 'primeng/textarea';
import {InputTextModule} from 'primeng/inputtext';
import {TranslocoPipe} from '@jsverse/transloco';
import {DirectusTooltipComponent} from '../../../directus-tooltip/directus-tooltip.component';

@Component({
  selector: 'app-model-field-textarea',
  imports: [
    CommonModule,
    FormsModule,
    TextareaModule,
    InputTextModule,
    TranslocoPipe,
    DirectusTooltipComponent,
  ],
  templateUrl: './model-field-textarea.component.html',
  styleUrl: './model-field-textarea.component.scss',
})
export class ModelFieldTextareaComponent {
  id = input.required<string>();
  label = input<string>('');
  tooltipKey = input<string>('');
  placeholder = input<string>('');
  isReadOnly = input<boolean>(false);
  smallLabel = input<boolean>(false);

  rows = input<number>(5);
  autoResize = input<boolean>(false);

  isRequired = input<boolean>(false);
  invalid = input<boolean>(false);

  value = model<string | null | undefined>();

  protected readonly isTouched = signal<boolean>(false);

  protected readonly showInvalid = computed<boolean>(
    () => this.isTouched() && (this.invalid() || (this.isRequired() && !this.value()?.trim())),
  );

  readonly readonlyText = computed(() => this.value() ?? '');

  protected markAsTouched(): void {
    this.isTouched.set(true);
  }
}
